module.exports = __webpack_public_path__ + "static/img/D01-杭州学军中学教育集团文渊中学1.9d37fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D01-杭州学军中学教育集团文渊中学1.png
// module id = Z45+
// module chunks = 0